export const therapyMethodsUrlByUuid: Record<string, string> = {
  'c3aba19f-3745-49d2-981d-cad40d02e8cf': 'art-terapiya',
  'daaa19f5-ff34-47d0-b075-eb86caef43c2': 'dialekticheskaya-povedencheskaya-terapiya',
  'ac2a8a4c-04a8-4111-ab85-d26d5127bbf0': 'emdr',
  '8b6332f8-e59c-4e24-b844-9c1a5e1697b3': 'emocionalno-obraznaya-terapiya',
  '8aeec23c-c0a6-404f-b425-c9ec5297bfe1': 'emocionalno-fokusirovannaya-terapiya',
  '4d0a7f6e-5a5d-48b9-a481-7af718270733': 'ekzistencialnaya-terapiya',
  '3a8f8304-dece-4cc5-a439-9336507a5e9e': 'geshtalt-terapiya',
  '37b82837-9433-47eb-945c-5768d749e2ce': 'kognitivno-povedencheskaya-terapiya',
  'e545e75d-fb34-4266-8b04-f8fc7f483aaf': 'kouching',
  '0a5d1f1b-5ca8-4399-9758-8cc6ade0c373': 'kratkosrochnaya-terapiya',
  'b17eb507-fb2e-4bb3-9661-d7112c68a1dd': 'lichnostno-centrirovannaya-terapiya',
  '6b4d9bfa-c10e-400f-8481-4c09c68f8eed': 'narrativnaya-praktika',
  '1fe5647b-800d-495a-b404-3d65831de1b3': 'pozitivnaya-psihoterapiya',
  '100b7907-033a-4a7d-b9d0-bd038cc2d5b0': 'psihoanaliz',
  '84d616b3-5be5-4cac-a90e-44e6a6928443': 'psihodinamicheskaya-terapiya',
  '92f96f86-31c2-464d-ad17-d2476e2dcbc9': 'psihodinamicheskij-podhod',
  'f66c9109-1e89-4577-9ac2-f486172e1ab9': 'psihodrama',
  'f2cfdafd-d8a2-4bf8-ae89-7dda9a239589': 'racionalno-emotivnaya-terapiya',
  '36fa106f-fd82-40d5-9926-c082fcd12959': 'semejnaya-terapiya',
  '2710faf2-5f93-43da-8b5d-959b51c32552': 'sistemnaya-terapiya-vnutrennih-semejnyh-sistem',
  'a0e5a603-0e68-4972-a14a-397b3b010d3a': 'shema-terapiya',
  '7f29e37c-f524-4f5d-ae68-c20717658a05': 'telesno-orientirovannaya-terapiya',
  '93dd6872-3560-4134-8917-4930aefd60d2': 'terapiya-prinyatiya-i-otvetstvennosti',
  '35a1ae6b-50b2-4012-ab71-5c78d57da1b0': 'terapiya-dlitelnogo-dejstviya',
  '849eaa69-730d-4b87-a047-d85acde360c0': 'terapiya-sfokusirovannaya-na-sostradanii',
  '0fe01b73-deb2-433c-b4b7-e6553a65c7e8': 'tranzaktnyj-analiz'
}

export function getMethodUrlByUuid(uuid: string | undefined): string | boolean {
    if (!uuid) return false;
    return therapyMethodsUrlByUuid?.[uuid] ? therapyMethodsUrlByUuid[uuid] : false;
}

export function checkIsMethodUrl(url: string): boolean {
    return Object.values(therapyMethodsUrlByUuid).includes(url);
}

